import posthog, { posthogEnabled } from "@/posthog";

export function recordSignInFailure({ accountRole, failureReason }) {
  if (!posthogEnabled) return;
  if (!["admin", "customer", "therapist"].includes(accountRole)) return;
  if (
    ![
      "account_pending",
      "account_unclaimed",
      "invalid_credentials",
    ].includes(failureReason)
  )
    return;

  posthog.capture("sign_in_failed", {
    account_role: accountRole,
    failure_reason: failureReason,
  });
}

export function recordSmsVerificationFailure({
  accountRole,
  failureReason,
  operation,
}) {
  if (!posthogEnabled) return;
  if (!["customer", "therapist"].includes(accountRole)) return;
  if (!["resend", "send", "verify"].includes(operation)) return;
  if (
    ![
      "expired",
      "invalid_code",
      "not_verified",
      "rate_limited",
      "resend_too_soon",
      "too_many_attempts",
    ].includes(failureReason)
  )
    return;

  posthog.capture("sms_verification_failed", {
    account_role: accountRole,
    failure_reason: failureReason,
    operation,
  });
}

export function recordBookingCreationFailure({ bookingMode, failureReason }) {
  if (!posthogEnabled) return;
  if (!["in_person", "video"].includes(bookingMode)) return;
  if (
    ![
      "booking_too_soon",
      "offer_not_available",
      "office_not_available",
      "outside_opening_hours",
      "overlaps_absence",
      "slot_already_booked",
      "slot_not_aligned",
      "slot_overlap",
      "slot_too_soon",
    ].includes(failureReason)
  )
    return;

  posthog.capture("booking_creation_failed", {
    booking_mode: bookingMode,
    failure_reason: failureReason,
  });
}

export function recordSessionExpired({ accountRole }) {
  if (!posthogEnabled) return;
  if (!["admin", "customer", "therapist"].includes(accountRole)) return;

  posthog.capture("session_expired", {
    account_role: accountRole,
  });
}
